import { render, staticRenderFns } from "./base-label.vue?vue&type=template&id=4250eb1a&scoped=true"
import script from "./base-label.vue?vue&type=script&lang=ts"
export * from "./base-label.vue?vue&type=script&lang=ts"
import style0 from "./base-label.vue?vue&type=style&index=0&id=4250eb1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4250eb1a",
  null
  
)

export default component.exports